import React, {useContext} from 'react';
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import moment from "moment/moment";
import {Grid, IconButton, Tooltip} from "@mui/material";
import BeatLoaderRegular from "../../../../components/loaders/BeatLoaderRegular";
import TrashIcon from "../../../../components/icons/TrashIcon";
import {greyishBlue500} from "../../../../assets/jss/main";
import {MissionListContext} from "../MissionListContext";
import PropTypes from 'prop-types';
import TaskStatusDisplay from "./TaskStatusDisplay";
import {WmsTaskStatus} from "../../../../utils/WMSTaskStatus";
import {FormattedMessage} from "react-intl";

MissionItem.propTypes = {
    mission: PropTypes.object.isRequired
};

function MissionItem({mission}) {
    const {
        loading,
        handleOpenDeleteMissionModal
    } = useContext(MissionListContext)

    const getTooltipContent = () => {
        if (WmsTaskStatus.CANCELLED === mission.status && !mission.metadata?.partiallyComplete) {
            return
        }

        return(
            <ul style={{margin: 0, padding: "8px"}}>
                {WmsTaskStatus.IN_PROGRESS === mission.status && (
                    <>
                        <li><FormattedMessage id={"wms.missionList.missionItem.tooltip.inTrolleyItems"} values={{itemCount: mission.inTrolleyItems}}/></li>
                        <li><FormattedMessage id={"wms.missionList.missionItem.tooltip.notFoundItems"} values={{itemCount: mission.notFoundItems}}/></li>
                        <li><FormattedMessage id={"wms.missionList.missionItem.tooltip.canceledItems"} values={{itemCount: mission.canceledItems}}/></li>
                    </>
                )}

                <li><FormattedMessage id={"wms.missionList.missionItem.tooltip.totalItems"} values={{itemCount: mission.totalItems}}/></li>
            </ul>
        )
    }

    const getMissionMember = () => {
        if (WmsTaskStatus.CANCELLED === mission.status && mission.metadata?.partiallyComplete) {
            return mission.metadata.pastAssociatedMemberFullName
        }

        return mission.member?.user.fullName ?? "N/A"
    }

    return (
        <TableRow>
            <TableCell>
                {mission.name}
            </TableCell>
            <TableCell>
                <Tooltip title={getTooltipContent()} arrow placement="top" key={mission.id}>
                    <span>
                        <TaskStatusDisplay missionStatus={mission.status} isPartiallyComplete={mission.metadata?.partiallyComplete || false}/>
                    </span>
                </Tooltip>
            </TableCell>
            <TableCell>
                {moment(mission.createdAt).format('DD/MM/YYYY') || " - "}
            </TableCell>
            <TableCell>
                {moment(mission.updatedAt).format('DD/MM/YYYY - H:m:s') || " - "}
            </TableCell>
            <TableCell>
                {getMissionMember()}
            </TableCell>
            <TableCell>
                <Grid item sx={{width: '80px'}}>
                    {loading && (
                        <Grid container justifyContent={"start"}>
                            <BeatLoaderRegular loading={true} size={10} />
                        </Grid>
                    )}

                    {!loading && WmsTaskStatus.IN_PROGRESS !== mission.status && (
                        <Grid item container justifyContent={"start"}>
                            <IconButton onMouseDown={() => {
                                handleOpenDeleteMissionModal(mission)
                            }}>
                                <TrashIcon color={greyishBlue500} size={18}/>
                            </IconButton>
                        </Grid>
                    )}
                </Grid>
            </TableCell>
        </TableRow>
    )
}

export default MissionItem;